import { Link } from "react-router-dom";
import { hotArticles, getCategoryName } from "@/mocks/articles";
import SectionHeading from "@/components/base/SectionHeading";

export default function TrendingSection() {
  const list = hotArticles.slice(0, 7);
  const spotlight = hotArticles[0];

  return (
    <section id="trending" className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-100/60">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <SectionHeading
          eyebrow="实时热瓜榜"
          title="此刻大家都在追的瓜线"
          desc="按讨论热度实时排序，每一条都附了背景梳理与最新进展，点开就能补齐前因后果。"
        />
        <Link
          to="/hot"
          className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
        >
          查看完整榜单
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <ol className="lg:col-span-7 flex flex-col gap-2.5">
          {list.map((article, index) => (
            <li key={article.slug}>
              <Link
                to={`/article/${article.slug}`}
                className="group flex items-center gap-4 p-3.5 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
              >
                <span
                  className={`w-9 h-9 shrink-0 rounded-md flex items-center justify-center text-sm font-bold ${
                    index < 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span>{getCategoryName(article.categoryId)}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3 className="mt-1 text-sm md:text-base font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                </div>
                <div className="hidden sm:flex flex-col items-end shrink-0">
                  <span className="flex items-center gap-1 text-xs text-primary-600 font-medium">
                    <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
                    热度 {article.heat}
                  </span>
                  <span className="mt-2 w-24 h-1.5 rounded-full bg-background-200 overflow-hidden">
                    <span
                      className="block h-full rounded-full bg-accent-500"
                      style={{ width: `${article.heat}%` }}
                    ></span>
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ol>

        <div className="lg:col-span-5">
          <Link
            to={`/article/${spotlight.slug}`}
            className="group relative block h-full min-h-[320px] rounded-lg overflow-hidden"
          >
            <img
              src={spotlight.cover}
              alt={`${spotlight.title} — 热瓜榜头名配图`}
              title={`${spotlight.title} 专题配图`}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-foreground-950/10"></div>
            <div className="relative h-full flex flex-col justify-end p-6 md:p-7">
              <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium">
                <i className="ri-trophy-line w-4 h-4 flex items-center justify-center"></i>
                本期瓜王
              </span>
              <h3 className="mt-4 text-xl md:text-2xl font-bold text-background-50 leading-snug">
                {spotlight.title}
              </h3>
              <p className="mt-3 text-sm text-background-200 leading-relaxed line-clamp-2">
                {spotlight.excerpt}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs text-background-200">
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line w-4 h-4 flex items-center justify-center"></i>
                  {(spotlight.views / 1000).toFixed(1)}k 阅读
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center"></i>
                  {spotlight.comments} 讨论
                </span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}